import { ParentVM, SectionVM, TrascrizioneCittadinanza } from 'civil-status/view-models/step-form';

export const transformerTrascrizioneCittadinanza = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataGenitoreTrasmetteCittadinanza?: SectionVM,
  dataRicGenitoreItaliano?: SectionVM,
  dataEsiAccProvvSindaco?: SectionVM,
  subjectIntest1?: ParentVM,
  transcriptionCitizenship?: SectionVM,
  dataCittadinanza?: SectionVM,
  subjectCittadinanza?: ParentVM
): TrascrizioneCittadinanza | undefined => {
  if (
    !(
      dataSection ||
      dataGenitoreTrasmetteCittadinanza ||
      dataRicGenitoreItaliano ||
      dataEsiAccProvvSindaco ||
      subjectIntest1 ||
      transcriptionCitizenship ||
      dataCittadinanza ||
      subjectCittadinanza
    )
  ) {
    return undefined;
  }

  return {
    key: idEvento
      ? {
          idEvento,
        }
      : undefined,
    dataMatrimonio: dataSection?.dateMarriage
      ? dataSection?.dateMarriage.toFormat('yyyy-MM-dd')
      : undefined,
    dataComunicazione: dataSection?.dateTranscription
      ? dataSection?.dateTranscription?.toFormat('yyyy-MM-dd')
      : dataEsiAccProvvSindaco?.dateTranscription
      ? dataEsiAccProvvSindaco?.dateTranscription?.toFormat('yyyy-MM-dd')
      : dataCittadinanza?.dateTranscription
      ? dataCittadinanza?.dateTranscription?.toFormat('yyyy-MM-dd')
      : undefined,
    trascrizione:
      dataSection?.templateTranscriptionText ||
      dataEsiAccProvvSindaco?.templateTranscriptionText ||
      undefined,
    dataAccertamento: dataSection?.dateOutcomeVerification
      ? dataSection?.dateOutcomeVerification?.toFormat('yyyy-MM-dd')
      : undefined,
    esitoAccertamento:
      dataSection?.assessmentResult || dataEsiAccProvvSindaco?.assessmentResult || undefined,
    dataProvvedimentoSindaco: dataEsiAccProvvSindaco?.dateMeasureMayor
      ? dataEsiAccProvvSindaco?.dateMeasureMayor?.toFormat('yyyy-MM-dd')
      : undefined,
    dataEfficaciaProvvedEstero: dataEsiAccProvvSindaco?.dateEffectiveMeasure
      ? dataEsiAccProvvSindaco?.dateEffectiveMeasure?.toFormat('yyyy-MM-dd')
      : undefined,
    protocollo: dataEsiAccProvvSindaco?.protocolNumber || undefined,
    genitoreConCittadinanza:
      dataGenitoreTrasmetteCittadinanza?.parentTransmittedCitizenship ||
      dataRicGenitoreItaliano?.parentRecognition ||
      undefined,
    dichiarazione: dataSection?.typeRequest || dataCittadinanza?.typeRequest || undefined,
    flagCambioGeneralita: subjectIntest1
      ? subjectIntest1.generality?.isChangeSurnameName
        ? '1'
        : '0'
      : undefined,
    flagRichiestaPerPosta: transcriptionCitizenship
      ? transcriptionCitizenship.isReceivedByPost
        ? '1'
        : '0'
      : undefined,
    ulterioreCittadinanza: subjectCittadinanza?.generality?.otherCitizenship?.idAnpr || undefined,
    nomeUlterioreCittadinanza:
      subjectCittadinanza?.generality?.otherCitizenship?.value || undefined,
  };
};
